// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from 'react';
import { MenuContainer } from './style';
import { Header } from './main/';
import { SideMenu } from './side-menu';
import { LangDrawer } from './lang-drawer';
import { AssistanceDrawer } from './assistance-drawer';
import { DownloadDrawer } from '../../download-center/download-drawer';
import { useTransport } from '../../../hook/use-transport';
export const MenuV2Component = (props) => {
    const { hidden } = props;
    const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
    const [isAssistanceMenuOpen, setIsAssistanceMenuOpen] = useState(false);
    const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
    const [isDownloadDrawerOpen, setIsDownloadDrawerOpen] = useState(false);
    const { transport } = useTransport();
    useEffect(() => {
        transport.onEvent('ui.downloadRequested', () => {
            setIsDownloadDrawerOpen(true);
        });
    });
    return (React.createElement(MenuContainer, null,
        React.createElement("div", { className: `root-app_menu menu-v2 ${hidden ? 'hidden' : ''}` },
            React.createElement(Header, { isOpenSideMenu: isSideMenuOpen, toggleSideMenu: () => setIsSideMenuOpen(!isSideMenuOpen), openLangMenu: () => setIsLangMenuOpen(true), openAssistanceMenu: () => setIsAssistanceMenuOpen(true), openDownloadMenu: () => setIsDownloadDrawerOpen(true) }),
            React.createElement(SideMenu, { isOpen: isSideMenuOpen, hidden: hidden }),
            React.createElement(LangDrawer, { isOpen: isLangMenuOpen, onClose: () => setIsLangMenuOpen(false) }),
            React.createElement(AssistanceDrawer, { isOpen: isAssistanceMenuOpen, onClose: () => setIsAssistanceMenuOpen(false) }),
            React.createElement(DownloadDrawer, { isOpen: isDownloadDrawerOpen, onClose: () => setIsDownloadDrawerOpen(false) }))));
};
//# sourceMappingURL=component.js.map